module.exports = __webpack_public_path__ + "img/head-notice.02d9ad3e.svg";